import { useCallback, useEffect, useRef } from 'react'

// Components are keyed to the authenticated identity/workshop/customer. Every
// request also gets a ticket so reloads and unmounts invalidate all late branches.
export function useReviewRequest() {
  const sequence = useRef(0)
  useEffect(() => () => { sequence.current++ }, [])
  return useCallback(() => {
    const ticket = ++sequence.current
    return () => ticket === sequence.current
  }, [])
}
